import IPBoardPart from 'src/app/model/product/ip-board/ip-board-part';
import {
  IPBoardConfigurationChangedEvent,
  SignSelectedEvent
} from 'src/app/services/project-display-observable.service';
import { SignWithStockAmount } from '../client-sign-selector/sign-with-stock-amount';

export class ClientIPBoardFormHelper {
  private constructor() {}

  static getAvailableStock(signWithStockAmount: SignWithStockAmount): number {
    return (
      (signWithStockAmount.totalStock == null
        ? 0
        : signWithStockAmount.totalStock) +
      (signWithStockAmount.orderedAmount == null
        ? 0
        : signWithStockAmount.orderedAmount)
    );
  }

  static matchesEvent(
    ipBoardPart: IPBoardPart,
    event: SignSelectedEvent | IPBoardConfigurationChangedEvent
  ): boolean {
    return (
      (ipBoardPart != null &&
        (ipBoardPart.id != null &&
          event.ipBoardPart.id != null &&
          ipBoardPart.id === event.ipBoardPart.id)) ||
      ipBoardPart === event.ipBoardPart
    );
  }
}
